// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__O0e5x","link":"Nav_link__cZSK8","active":"Nav_active__DUQVZ"};